import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { Observable, take } from 'rxjs';

import { CdwSearchGridComponentStore } from '../+component-state/cdw-search-grid-component.store';

@Component({
  selector: 'lib-select-checkbox',
  templateUrl: './select-checkbox.component.html',
  styleUrls: ['./select-checkbox.component.scss'],
  standalone: true,
  imports: [AsyncPipe, CdwCheckboxModule],
})
export class SelectCheckboxComponent<T extends { id: string }>
  implements ICellRendererAngularComp
{
  public isSelected$!: Observable<boolean>;

  public selectAll$!: Observable<boolean>;

  private id!: string;

  constructor(
    private readonly componentState: CdwSearchGridComponentStore<T>
  ) {}

  public agInit(params: ICellRendererParams<T>): void {
    if (params.data?.id) {
      this.id = params.data.id;
      this.isSelected$ = this.componentState.isIdSelected({ id: this.id });
      this.selectAll$ = this.componentState.selectAll$;
    }
  }

  // this method is needed to fulfill the ICellRendererAngularComp interface
  public refresh(): boolean {
    return false;
  }

  public onClick(event$: MouseEvent): void {
    event$.stopPropagation();
    this.componentState.toggleSelectedId({ id: this.id });
    this.componentState.updateMultiSelectCheckboxState();
    this.componentState.turnOffPromptSelectAll();
    this.isSelected$.pipe(take(1)).subscribe((isSelected: boolean): void => {
      if (!isSelected) {
        this.componentState.turnOffFilterBySelected();
      }
    });
  }
}
